import React from 'react';
// Icons
import { FaDumbbell, FaBrain, FaCameraRetro, FaFire, FaSeedling, FaBalanceScale } from 'react-icons/fa';

function WellnessJourneySection() {
  return (
    <section className='grid gap-y-8 px-8 py-8 xl:py-16 2xl:px-32 lg:px-16'>
      <div className='grid gap-y-4 justify-center'>
        <h3 className='font-titleFont text-2xl text-center border-b-2 border-solid border-colour2 dark:border-colour3 pb-2'>
          My Journey & Focus
        </h3>
      </div>

      <div className='grid lg:grid-cols-3 gap-6 dark:text-colour2'>
        {/* Overweight → Fit */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaDumbbell className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>From Overweight → Fit</h4>
          </div>
          <p className='text-sm'>
            I faced struggles with health and self-image, learned discipline and consistency, and
            turned fitness into a lifestyle—not just a goal.
          </p>
        </article>

        {/* Mindset Matters */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaBrain className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>Mindset Matters</h4>
          </div>
          <p className='text-sm'>
            Mental Trainer educated: I guide mindset and motivation so you can overcome barriers.
            Mental strength fuels physical strength.
          </p>
        </article>

        {/* Creative Spark */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaCameraRetro className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>Creative Spark</h4>
          </div>
          <p className='text-sm'>
            Filming, photography, and editing—storytelling through visuals that keep you inspired and accountable.
          </p>
        </article>

        {/* Core Values */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaSeedling className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>Core Values</h4>
          </div>
        <ul className='grid gap-2 text-sm'>
            <li><span className='font-semibold'>Growth</span> — always improving</li>
            <li><span className='font-semibold'>Resilience</span> — turning challenges into wins</li>
            <li><span className='font-semibold'>Creativity</span> — expressing through content</li>
            <li><span className='font-semibold'>Inspiration</span> — motivating others by example</li>
          </ul>
        </article>

        {/* Where It All Connects */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaBalanceScale className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>Where It All Connects</h4>
          </div>
          <p className='text-sm'>
            The discipline of fitness, the mindset of a trainer, and the creativity of a storyteller—combined
            into a mission to inspire and create real impact.
          </p>
        </article>

        {/* Mental + Physical Wellness (summary card) */}
        <article className='grid gap-3 bg-colour1 rounded-3xl shadow-md p-6'>
          <div className='grid grid-flow-col items-center gap-3 w-fit'>
            <FaDumbbell className='text-colour5 text-xl' aria-hidden='true' />
            <h4 className='text-lg font-semibold'>Mental & Physical Wellness</h4>
          </div>
          <p className='text-sm'>
            Tailored plans for mind and body with weekly check-ins—online, 1:1, or groups. Practical steps,
            real progress, sustainable change.
          </p>
        </article>
      </div>
    </section>
  );
}

export default WellnessJourneySection;
